import { window } from 'pro-gallery-lib';
export function isGalleryInViewport(container) {
    try {
        var haveAllVariablesForViewPortCalc = !!(container &&
            Number.isInteger(container.scrollBase) &&
            Number.isInteger(container.galleryHeight) &&
            window &&
            window.document &&
            window.document.documentElement &&
            (Number.isInteger(window.document.documentElement.scrollTop) ||
                (window.document.scrollingElement &&
                    Number.isInteger(window.document.scrollingElement.scrollTop))) &&
            Number.isInteger(window.document.documentElement.offsetHeight));
        var inTopViewPort = haveAllVariablesForViewPortCalc &&
            container.scrollBase + container.galleryHeight >
                window.document.documentElement.scrollTop;
        var inBottomViewPort = haveAllVariablesForViewPortCalc &&
            container.scrollBase <
                (window.document.documentElement.scrollTop ||
                    window.document.scrollingElement.scrollTop) +
                    window.document.documentElement.offsetHeight;
        return ((inTopViewPort && inBottomViewPort) || !haveAllVariablesForViewPortCalc); // if some parameters are missing (haveAllVariablesForViewPortCalc is false) we still want the used functionality to work
    }
    catch (e) {
        console.warn('Could not calculate viewport', e);
        return true;
    }
}
//# sourceMappingURL=galleryHelpers.js.map